import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { useContent } from "../context/ContentContext";

const LINKS = [
  { label: "Chi siamo", href: "#chi-siamo" },
  { label: "Servizi", href: "#servizi" },
  { label: "Lavorazioni", href: "#processo" },
  { label: "Galleria", href: "#galleria" },
  { label: "Contatti", href: "#contatti" },
];

export const Navbar = () => {
  const { content } = useContent();
  const COMPANY = content.company;
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="navbar"
      initial={{ y: -80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-paper/90 backdrop-blur-md border-b border-gold/20" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#hero" data-testid="nav-logo" className="flex items-center gap-3">
          <img src={COMPANY.logo} alt="Cancella Infissi" className="h-16 md:h-[68px] w-auto object-contain" />
        </a>

        <ul className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                data-testid={`nav-link-${l.href.slice(1)}`}
                className="link-underline text-[0.8rem] uppercase tracking-[0.18em] text-navy/80 hover:text-navy transition-colors"
              >
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <a
          href={`tel:${COMPANY.phoneHref}`}
          data-testid="nav-call-btn"
          className="hidden md:inline-flex items-center gap-2 border border-navy text-navy px-5 py-2.5 text-[0.72rem] uppercase tracking-[0.2em] hover:bg-navy hover:text-paper transition-all duration-300"
        >
          <Phone size={14} /> Chiamaci
        </a>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-navy"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-paper border-t border-gold/20"
          >
            <ul className="flex flex-col px-6 py-4">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    onClick={() => setOpen(false)}
                    className="block py-3 text-sm uppercase tracking-[0.18em] text-navy/80 border-b border-gold/10"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <a href={`tel:${COMPANY.phoneHref}`} className="mt-4 inline-flex items-center gap-2 justify-center bg-navy text-paper py-3 text-xs uppercase tracking-[0.2em]">
                <Phone size={14} /> {COMPANY.phone}
              </a>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
